import { Action } from '@ngrx/store';
import { ModulesState } from './modules.state';

export const GET_ROUTES = 'GETTING ROUTES FROM DB';
export const SET_ROUTES = 'RETURN ROUTES FROM STORE';
export const DELETE_ROUTES = 'DELETE ROUTES FROM STORE';

export class GetRoutes implements Action {
	readonly type = GET_ROUTES;
	constructor(readonly payload: ModulesState) { }
}

export class SetRoutes implements Action {
	readonly type = SET_ROUTES;
	constructor(readonly payload: ModulesState) { }
}

export class DeleteRoutes implements Action {
	readonly type = DELETE_ROUTES;
	constructor(readonly payload: ModulesState) {
		payload.route = [];
	}
	
}


export type Actions = GetRoutes|SetRoutes|DeleteRoutes ;
